import React from 'react';
import NewGameState from '../../../_types/NewGameState';
import RewardType from '../../../_types/RewardType';
import CustomTextInput from '../../../custom-inputs/CustomTextInput';
import CustomSelectRewards from '../../../custom-inputs/CustomSelectRewards';

interface Props {
  rewards: RewardType[];
  newGameState: NewGameState;
  onChangeNewGameState: (newGameState: NewGameState) => void;
}

const IfPlacedInputs: React.FC<Props> = ({
  rewards,
  newGameState,
  onChangeNewGameState,
}) => {
  if (newGameState.rewardWhen !== 'mission') {
    return null;
  }

  if (newGameState.rewardCurrency === 'points') {
    return (
      <>
        <CustomTextInput
          label="1st Place Coins"
          value={newGameState.rewardCount1}
          onChange={(newValue) => {
            onChangeNewGameState({ ...newGameState, rewardCount1: newValue });
          }}
        />
        <CustomTextInput
          label="2nd Place Coins"
          value={newGameState.rewardCount2}
          onChange={(newValue) => {
            onChangeNewGameState({ ...newGameState, rewardCount2: newValue });
          }}
        />
        <CustomTextInput
          label="3rd Place Coins"
          value={newGameState.rewardCount3}
          onChange={(newValue) => {
            onChangeNewGameState({ ...newGameState, rewardCount3: newValue });
          }}
        />
        <CustomTextInput
          label="Participant Coins"
          value={newGameState.rewardCountP}
          onChange={(newValue) => {
            onChangeNewGameState({ ...newGameState, rewardCountP: newValue });
          }}
        />
      </>
    );
  }

  return (
    <>
      <CustomSelectRewards
        label="1st place reward*"
        value={newGameState.rewardName1}
        onSelect={(reward: RewardType) => {
          console.log('reward', reward);
          onChangeNewGameState({
            ...newGameState,
            rewardID1: reward.id,
            rewardName1: reward.name,
            showCustomReward1: false,
          });
        }}
        items={rewards}
      />
      <CustomSelectRewards
        label="2nd place reward"
        value={newGameState.rewardName2}
        onSelect={(reward: RewardType) => {
          onChangeNewGameState({
            ...newGameState,
            rewardID2: reward.id,
            rewardName2: reward.name,
            showCustomReward2: false,
          });
        }}
        items={rewards}
      />
      <CustomSelectRewards
        label="3rd place reward"
        value={newGameState.rewardName3}
        onSelect={(reward: RewardType) => {
          onChangeNewGameState({
            ...newGameState,
            rewardID3: reward.id,
            rewardName3: reward.name,
            showCustomReward3: false,
          });
        }}
        items={rewards}
      />
      {/* <CustomSelectRewards
        label="Participant Reward"
        value={newGameState.rewardNameP}
        onSelect={(reward: RewardType) => {
          onChangeNewGameState({
            ...newGameState,
            rewardIDp: reward.id,
            rewardNameP: reward.name,
            showCustomReward1: false,
          });
        }}
        items={rewards}
      />
      <CustomSelectRewards
        label="If Tied (Multiple people/teams have the same result)"
        value={newGameState.rewardName1t}
        onSelect={(reward: RewardType) => {
          onChangeNewGameState({
            ...newGameState,
            rewardID1t: reward.id,
            rewardName1t: reward.name,
            showCustomReward1: false,
          });
        }}
        items={rewards}
      /> */}
    </>
  );
};

export default IfPlacedInputs;
